import { useMemo } from "react";

export type ShowNotificationArgs = {
  type?: "info" | "warn" | "alert";
  content: string;
  timeout?: number;
};

const showNotification = ({
  type = "warn",
  content,
  timeout = 6000,
}: ShowNotificationArgs) => {
  dispatchEvent(
    new CustomEvent("ldNotificationAdd", {
      detail: {
        content,
        type,
        timeout,
      },
    })
  );
};

const removeCurrentNotification = () =>
  dispatchEvent(new CustomEvent("ldNotificationDismiss"));

const clearAllNotifications = () =>
  dispatchEvent(new CustomEvent("ldNotificationClear"));

function useNotification() {
  return useMemo(
    () => ({
      showNotification,
      removeCurrentNotification,
      clearAllNotifications,
    }),
    []
  );
}

export {
  useNotification,
  showNotification,
  removeCurrentNotification,
  clearAllNotifications,
};
